export default {"src":"/_next/static/media/faq-icon8.f24ba96d.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};